import { render, staticRenderFns } from "./PelatihanPesertaPreTest.vue?vue&type=template&id=5ea18409"
import script from "./PelatihanPesertaPreTest.vue?vue&type=script&lang=js"
export * from "./PelatihanPesertaPreTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports